import { Scale, MapPin } from "lucide-react";

const practiceLabels = [
  "General Litigation",
  "Sports Law",
  "Taxation",
  "IPR",
  "Corporate Law",
  "Arbitration",
  "White Collar Crime Litigation",
];

const trustItems = [
  { icon: Scale, label: "Bar Council of India — Registered" },
  { icon: MapPin, label: "Nationwide Representation" },
];

export default function TrustBar() {
  return (
    <section data-testid="trust-bar" className="bg-navy-base border-y border-gold/10">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-8 space-y-6">
        <div className="flex flex-wrap justify-center gap-x-12 gap-y-4">
          {trustItems.map((item, i) => (
            <div
              key={item.label}
              className="flex items-center gap-3 animate-on-scroll"
              data-testid={`trust-item-${i}`}
            >
              <item.icon className="w-5 h-5 text-gold flex-shrink-0" />
              <span className="text-sm text-gray-300 font-body whitespace-nowrap">{item.label}</span>
            </div>
          ))}
        </div>
        <div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-3">
          {practiceLabels.map((label, i) => (
            <span key={label} className="flex items-center gap-3" data-testid={`practice-label-${i}`}>
              <span className="text-sm text-gray-300 font-body whitespace-nowrap">{label}</span>
              {i < practiceLabels.length - 1 && (
                <span className="text-gold/40 text-xs">|</span>
              )}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
